// WalletHistoryForm.jsx
import React, { useState } from "react";
import axios from "axios";
import {toast} from "react-toastify"
import { useNavigate } from "react-router-dom";

const WalletHistoryForm = () => {
  const [formData, setFormData] = useState({
    userId: "",
    status: "success",
    paymentId: "",
    orderId: "",
    amount:""
  });

  const navigate=useNavigate()
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${REACT_APP_BACKEND_URL}/adminBilling/add-history`, formData);
      toast.success("History added successfully");
      navigate("/finance/billing/walletHistory")
    //   alert("History added successfully");
    } catch (err) {
        toast.error(err.response?.data?.message)
        
    //   alert("Error: " + err.response?.data?.message || "Server Error");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 bg-white p-6 rounded shadow">
      <h2 className="text-[18px] font-bold mb-4">Add Wallet History</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="userId"
          placeholder="User ID"
          value={formData.userId}
          onChange={handleChange}
          className="w-full p-2 border rounded"
          required
        />
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="w-full p-2 border rounded"
        >
          <option value="success">Success</option>
          <option value="failed">Failed</option>
        </select>
        <input
          type="text"
          name="paymentId"
          placeholder="Payment ID"
          value={formData.paymentId}
          onChange={handleChange}
          className="w-full p-2 border rounded"
          required
        />
        <input
          type="text"
          name="orderId"
          placeholder="Order ID"
          value={formData.orderId}
          onChange={handleChange}
          className="w-full p-2 border rounded"
          required
        />
        <input type="text" name="amount" placeholder="Amount" value={formData.amount} onChange={handleChange} className="w-full p-2 border rounded"
          required />
        <button
          type="submit"
          className="w-full bg-[#0CBB7D] text-white py-2 rounded hover:bg-[#0CBB7D]"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default WalletHistoryForm;
